import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { CoreData } from "../tools/core-data/core-data";
import { LoadingTask } from "../tools/ui/loading-task";
import { BaseService } from "./base-service";
import { catchError, finalize, map } from "rxjs";
import { Cassette } from "../domain/cassette";
import { mapper } from "../tools/mapping/mapper";
import { CassetteDTO } from "./dto/cassette.dto";

@Injectable({
    providedIn: 'root',
})
export class ProcessService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/processTerrain`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getAutomatiquePompeOPData(cassetteList: Cassette[]) {
        this.loadingTask.activateLoading();

        return this.http.post(`${this.serviceUrl}/automaticPompeOPData`, cassetteList, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getAutomatiquePompeOPData')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: CassetteDTO[]) => {
                return response.map(item => mapper.map(item, CassetteDTO, Cassette));
            }));
    }
}